import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";

import { Link, useNavigate } from "react-router-dom";

// Formik Validation
import { useFormik } from "formik";
import * as Yup from "yup";

// action

// import images
import { useMutation } from "@apollo/client";
import { useLocation } from "react-router-dom";
import logo from "../assets/image/logo.svg";
import profile from "../assets/image/profile-img.png";
import OtpVerificationModal from "../Component/Modals/OtpVerificationModal";
import {
  SUPER_ADMIN_OTP_FORGET_PASSWORD,
  SUPER_ADMIN_OTP_RESET_PASSWORD,
} from "../heleper/graphql_helper";
import toast, { Toaster } from "react-hot-toast";
import "./forgotPassword.css";

const ForgetPasswordPage = (props) => {
  //meta title
  const location = useLocation();
  const isClientRedirected = location?.state?.isClientRedirected || false;
  document.title = "Bewta";
  const history = useNavigate();
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [modal, setModal] = useState(false);

  const [forgetAdminPasswordCallback, { loading: otpLoaderAdmin }] =
    useMutation(SUPER_ADMIN_OTP_FORGET_PASSWORD);
  const [resetAdminPasswordCallback, { loading: resetAdminPasswordLoader }] =
    useMutation(SUPER_ADMIN_OTP_RESET_PASSWORD);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: async ({ email }) => {
      try {
        const response = await forgetAdminPasswordCallback({
          variables: {
            email: email?.trim()?.toLowerCase(),
          },
        });
        setModal(true);
        toast.success(
          response?.data?.sendOTPAdmin?.message || "OTP sent successfully."
        );
      } catch (error) {
        toast.error(
          error?.message ||
            "An error occurred during sending OTP, please try again later."
        );
      }
    },
  });

  const resetPassword = async () => {
    if (otp.length < 4) {
      toast.error("OTP must be at least 4 digits long.");
      return;
    }

    if (!password) {
      toast.error("Password cannot be empty.");
      return;
    }

    try {
      const response = await resetAdminPasswordCallback({
        variables: {
          email: validation.values.email?.trim()?.toLowerCase(),
          otp: parseInt(otp),
          password,
        },
      });
      setModal(false);
      toast.success(
        response?.data?.resetAdminOTPPassword?.message ||
          "Password updated successfully."
      );
      history("/login");
    } catch (error) {
      toast.error(
        error?.message || "An error occurred please try again later."
      );
    }
  };

  return (
    <React.Fragment>
      <OtpVerificationModal
        modal={modal}
        setModal={setModal}
        otp={otp}
        setOtp={setOtp}
        password={password}
        setPassword={setPassword}
        loading={resetAdminPasswordLoader}
        onClick={resetPassword}
        resendClick={validation.handleSubmit}
      />
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden card">
                <div className="bg-primary bg-softbg-soft-primary">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to Bewta.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div
                        style={{
                          height: "4.5rem",
                          width: "4.5rem",
                          marginTop: "-26px",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            alignItems: "center",
                            backgroundColor: "#EFF2F7",
                            color: "white",
                            display: "flex",
                            fontWeight: "500",
                            height: "100%",
                            justifyContent: "center",
                          }}
                          className="rounded-circle"
                        >
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="submit"
                            disabled={otpLoaderAdmin}
                          >
                            {otpLoaderAdmin ? "Loading..." : "Send OTP"}
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link
                    to={isClientRedirected ? "customer-login" : "login"}
                    className="font-weight-medium text-primary"
                  >
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Bewta. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Toaster />
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default ForgetPasswordPage;
